import UsuariosPreparacaoTypes from './types';

const INITIAL_STATE = {
  dados: []
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UsuariosPreparacaoTypes.SEARCH_REQUEST:
      return {
        ...state,
        create: false,
          loading: true
      }

      case UsuariosPreparacaoTypes.SEARCH_FAILURE:
        return {
          ...state,
          create: false,
            delete: false,
            loading: false,
            error: true
        }

        case UsuariosPreparacaoTypes.SEARCH_SUCCESS:
          return {
            ...state,
            dados: action.payload,
              create: false,
              delete: false,
              loading: false,
              error: false
          }
          case UsuariosPreparacaoTypes.CREATE_SUCCESS:
            return {
              ...state,
              item: action.data,
                create: true,
                delete: false,
                loading: false,
                error: false
            }
            case UsuariosPreparacaoTypes.DELETE_SUCCESS:
              return {
                ...state,
                item: action.data,
                  create: false,
                  delete: true,
                  loading: false,
                  error: false
              }
              default:
                return state;
  }
}
